import { createStyles } from '@material-ui/core/styles';

const styles = () =>
  createStyles({
    root: {
      fill: 'transparent',
      fontSize: 17,
      height: 16,
      width: 16,
    },
  });

export default styles;
